function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center',
                  justifyContent:'center', padding:'4rem 2rem', gap:'1rem' }}>
      <div style={{
        width: 40, height: 40,
        border: '3px solid #E2E8F0',
        borderTop: '3px solid #0E7C7B',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ color:'#64748B', fontSize:'0.9rem' }}>{message}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default LoadingSpinner;
